export default "__VITE_ASSET__8905746a__"